import { lazy, Suspense, useEffect, useState } from 'react'
import { router } from '@inertiajs/react'

const AgentRoot = lazy(() => import('./AgentRoot'))

// Mounted once beside <App> (inertia.tsx), so the console survives page
// visits. The panel's code is its own chunk, fetched only for people who
// are signed in (spec §6.1).
export default function AgentMount({ signedIn: initiallySignedIn }: { signedIn: boolean }) {
  const [signedIn, setSignedIn] = useState(initiallySignedIn)

  // Sign-in and sign-out are Inertia visits. A partial reload can leave the
  // shared auth prop out, so only a page that carries auth counts.
  useEffect(
    () =>
      router.on('navigate', (event) => {
        const props = event.detail.page.props as { auth?: { user?: unknown } }
        if ('auth' in props) setSignedIn(Boolean(props.auth?.user))
      }),
    [],
  )

  if (!signedIn) return null
  return (
    <Suspense fallback={null}>
      <AgentRoot />
    </Suspense>
  )
}
